(ns common.transaction-process.templates.registry
  (:require
   [common.transaction-process.templates.capman.nest :as capman-nest]
   [common.transaction-process.templates.capman.other :as capman-other]
   [common.transaction-process.templates.capman.real-estate :as capman-real-estate]
   [common.transaction-process.templates.default :as default-template]))

(def templates
  {capman-nest/template-id        capman-nest/template
   capman-real-estate/template-id capman-real-estate/template
   capman-other/template-id       capman-other/template
   default-template/template-id   default-template/template})

(defn get-template
  [template-kw]
  (get templates template-kw))

(defn get-stage
  [template stage-id]
  (->> (:template/stages template)
       (filter #(= (:stage/id %) stage-id))
       first))

(defn get-team-roles
  [template]
  (:template/team-roles template))
